import React from "react";

export default function NoteList(props) {
  return (
    <div role="list" className="note-list" aria-labelledby="list-heading">
      {props.notes}
    </div>
  );
}
